import React, { Fragment } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import Admin from "../../../Component/Admin/Admin";

const AdminList = () => {
	return (
		<Fragment>
			<Breadcrumbs parent="Kelas" title="Daftar Admin" />
			<Admin />
		</Fragment>
	);
};
export default AdminList;
